import { Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { IconType } from '@se/cp.common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, ICellRendererParams } from 'ag-grid-community';

interface IButtonIconRendererConfig {
    icon: string;
    negate: boolean;
    tooltip?: string;
    iconType?: IconType;
    selectOnClick?: boolean;
    onClick?: () => void;
    onSelect?: () => void;
}

type TButtonIconRendererParams = ICellRendererParams<any, boolean, any> & { estensa: IButtonIconRendererConfig };

@Component({
    selector: 'se-button-icon-renderer',
    imports: [TranslatePipe, MatButtonModule, MatIconModule, MatTooltipModule],
    templateUrl: './button-icon-renderer.component.html',
    styleUrl: './button-icon-renderer.component.scss',
})
export class ButtonIconRendererComponent implements ICellRendererAngularComp {
    readonly EconTypes = IconType;
    readonly iconType = signal<IconType>(IconType.AngularMaterial);
    readonly icon = signal<string>('');
    readonly tooltip = signal<string>('');
    readonly isActive = signal<boolean>(false);
    action: (id: string) => void = (id: string) => {};
    selectOnClick: boolean = false;
    api?: GridApi;
    rowId: string = '';

    refresh(params: TButtonIconRendererParams): boolean {
        const newValue = params.estensa.negate ? !params.value : !!params.value;
        this.isActive.set(newValue);
        return true;
    }

    agInit(params: TButtonIconRendererParams): void {
        this.api = params.api;
        const initValue = params.estensa.negate ? !params.value : !!params.value;
        this.isActive.set(initValue);
        const iconType = params.estensa.iconType;
        if (iconType) this.iconType.set(iconType);
        const icon = params.estensa.icon;
        if (icon) this.icon.set(icon);
        const tooltip = params.estensa.tooltip;
        if (tooltip) this.tooltip.set(tooltip);
        const action = params.estensa.onClick;
        if (action) this.action = action;
        this.selectOnClick = !!params.estensa.selectOnClick;
        this.rowId = params.data.id ?? '';
    }

    select = () => {
        this.api?.deselectAll();
        const rowNode = this.api?.getRowNode(this.rowId);
        if (rowNode) this.api?.setNodesSelected({ nodes: [rowNode], newValue: true });
    };

    onClick = (event: MouseEvent) => {
        event.stopImmediatePropagation();
        event.preventDefault();
        if (this.selectOnClick) this.select();
        this.action(this.rowId);
    };
}
